import {
  Link,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContractsListQuery } from 'generated/graphql';
import moment from 'moment';
import { Link as RouterLink, useParams } from 'react-router-dom';

function ContractsList() {
  const { clientId } = useParams() as { clientId: string };
  const { data, loading } = useContractsListQuery({ variables: { clientId } });

  if (loading || !data) return null;

  const contracts = data.contracts.edges.map(edge => edge.node!);

  return (
    <TableContainer>
      <Table variant="simple">
        {!contracts.length && <TableCaption>This client does not have any contracts</TableCaption>}
        <Thead>
          <Tr>
            <Th>location</Th>
            <Th>suite</Th>
            <Th>start</Th>
            <Th>end</Th>
            <Th>action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {contracts.map(contract => (
            <Tr key={contract.id}>
              <Td>
                <FontAwesomeIcon icon={['fal', 'location-dot']} /> {contract.location.address}
              </Td>
              <Td>Suite #{contract.suite}</Td>
              <Td>{moment(contract.startOn).format('ll')}</Td>
              <Td>{moment(contract.endOn).format('ll')}</Td>
              <Td>
                <Tooltip label="Upload Contract File">
                  <Link
                    ml={2}
                    as={RouterLink}
                    to={`documents/new?documentType=contract&contractId=${contract.id}`}
                  >
                    <FontAwesomeIcon icon={['fal', 'cloud-arrow-up']} size="lg" />
                  </Link>
                </Tooltip>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
}

export default ContractsList;
